import type { IconBaseProps, IconType } from "react-icons";

import * as MD from "react-icons/md";
import * as FA from "react-icons/fa";
import * as PI from "react-icons/pi";
import * as RI from "react-icons/ri";
import * as GO from "react-icons/go";
import * as BS from "react-icons/bs";
import * as GR from "react-icons/gr";
import * as CI from "react-icons/ci";
import * as AI from "react-icons/ai";
import * as TI from "react-icons/ti";
import * as TFI from "react-icons/tfi";
import * as FI from "react-icons/fi";

// Cast each namespace to a map of React icon components
export type IconComponent = React.ComponentType<IconBaseProps>;

export const icons = {
  MD: MD as any,
  FA: FA as any,
  PI: PI as any,
  RI: RI as any,
  GO: GO as any,
  BS: BS as any,
  GR: GR as any,
  CI: CI as any,
  AI: AI as any,
  TI: TI as any,
  TFI: TFI as any,
  FI: FI as any,
} as const;
